import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import login_image from "../../assets/images/Auth/login.png";
import logo from "../../assets/images/Auth/tt-logo.png";
import { useNavigate } from "react-router-dom";
import { update2factor } from "../../apis/apiService.js";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../components/common/Loader.js";
import { useDispatch } from "react-redux";
import { setloginUserName } from "../../selectSlice.js";

function TwoFactorAuth({ token, setIsAuthenticated }) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [recoverycode,setRecoveryCode]=useState("")
  const inputRefs = useRef([]);
   const [isRecoveryMode, setIsRecoveryMode] = useState(false);
   const tokens = token || localStorage.getItem("access_token");
  // console.log(token,"tokennnnn")
  // const token = localStorage.getItem("access_token"); // ✅ read token
  //  localStorage.setItem("access_token", token);

  useEffect(() => {
  // Focus the first OTP box on mount
  inputRefs.current[0]?.focus();
}, []);


  const handleCheckboxChange = (e) => {
    setRemember(e.target.checked);
  };

const onSubmit = async (data) => {

  // console.log("Form data:", data);

  if (!tokens) {
    toast.error("Access token not found. Please login again.");
    return;
  }

  setLoading(true);
  try {
    // Build payload based on the mode
    const payload = isRecoveryMode
      ? {
          one_time_password: data.recovery_code,
          remember: remember,
        }
      : {
          one_time_password: data.OTP,
          remember: remember,
        };

    // console.log("Submitting payload:", payload);

    const response = await update2factor("verify-2fa", payload, tokens);

    if (response && response.status) {
       const { user, token: newToken } = response;
      if (user) {
         if (newToken) {
      localStorage.setItem("access_token", "secure-cookie-auth");
    }
        dispatch(setloginUserName(user));
      }

      if (setIsAuthenticated) setIsAuthenticated(true);
      toast.success("Logged in Successfully!");
      window.location.href = "/dashboard";
    } else {
      toast.error(response?.message || "Invalid OTP or recovery code");
    }
  } catch (error) {
    toast.error(error?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};



    const toggleMode = () => {
    setIsRecoveryMode(!isRecoveryMode);
    // clearErrors();
  };


const handleOtpChange = (e, index) => {
  const value = e.target.value.replace(/\D/g, ""); // allow only digits
  const newOtp = [...otp];

  // update current index with new value (can be empty)
  newOtp[index] = value;
  setOtp(newOtp);

  // update React Hook Form value
  setValue("OTP", newOtp.join(""));

  // move focus automatically if user typed a number
  if (value && index < otp.length - 1) {
    inputRefs.current[index + 1]?.focus();
  }
};

const handleKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    const newOtp = [...otp];

    if (otp[index]) {
      // just clear the current input
      newOtp[index] = "";
      setOtp(newOtp);
      setValue("OTP", newOtp.join(""));
    } else if (index > 0) {
      // move to previous input if current is empty
      newOtp[index - 1] = "";
      setOtp(newOtp);
      inputRefs.current[index - 1]?.focus();
      setValue("OTP", newOtp.join(""));
    }
  }
};


  // const onSubmit = (data) => {
  //   console.log("Form submitted:", data);
  //   alert(`Entered OTP: ${data.OTP}\nRemember: ${remember}`);
  // };

  useEffect(() => {
    const handleBack = () => {
      // 🚨 Remove token when going back
      localStorage.removeItem("access_token");

      navigate("/login", { replace: true });
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [navigate]);

  return (
    <div className="container-fluid">
      {loading ? (
        <Loader />
      ) : (
        <div className="row">
          {/* Left Side Image */}
          <div className="col-md-7 text-center p-5 login_bg">
            <img
              src={login_image}
              alt="Illustration"
              className="Authleft_img"
            />
          </div>

          {/* Right Side Form */}
          <div className="col-md-5 p-5">
            <div className="text-center">
              <img src={logo} alt="logo" />
            </div>

            <div className="my-4">
              <h3></h3>
              <p>
               {isRecoveryMode
    ? "Enter your recovery code."
    : "Enter the 6-digit code from your authenticator app."}
      </p>
            </div>

            <form className="login_form" onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3 flex-grow-1">
              <label htmlFor="OTP" className="form-label">
          {isRecoveryMode ? "Recovery Code" : "OTP"}{" "}
          <span className="text-danger">*</span>
        </label>
                
                  <div className="form-group mb-3 text-center">
                      {!isRecoveryMode ? (
                    <div className="d-flex  gap-2">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          type="text"
                          maxLength={1}
                          className={`form-control text-center fw-bold `}
                          value={digit}
                          onChange={(e) => handleOtpChange(e, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          ref={(el) => (inputRefs.current[index] = el)}
                          style={{
                            width: "45px",
                            height: "50px",
                            fontSize: "20px",
                            borderRadius: "8px",
                            border: "2px solid rgba(18, 183, 159, 1)",
                            color: "rgba(18, 183, 159, 1)",
                            backgroundColor: "transparent",
                            outline: "none",
                          }}
                        />
                      ))}
                    </div>
                      ):(
<input
  type="text"
  className="form-control text-center fw-bold mt-2"
  placeholder="Enter Recovery Code"
  value={recoverycode}
 onChange={(e) => {
    const val = e.target.value.replace(/\s+/g, ""); 
     if (val.length > 10) return;
  setRecoveryCode(val);
  setValue("recovery_code", val, { shouldValidate: true });
}}

  style={{
    width: "300px",
    fontSize: "18px",
    borderRadius: "8px",
    border: "2px solid rgba(18, 183, 159, 1)",
    color: "rgba(18, 183, 159, 1)",
    backgroundColor: "transparent",
    outline: "none",
  }}
/>

                      )}

                    {/* Hidden input to connect with React Hook Form */}
                    <input
  type="hidden"
  {...register("OTP", {
    required: !isRecoveryMode ? "OTP is required" : false,
    validate: (value) =>
      !isRecoveryMode
        ? value.length === otp.length || "Please enter OTP"
        : true,
  })}

  {...register("recovery_code", {
  required: isRecoveryMode ? "Recovery code is required" : false,
  validate: (value) =>
    isRecoveryMode && value.trim() === ""
      ? "Recovery code is required"
      : true,
})}

/>

                      {errors.OTP && !isRecoveryMode && (
            <div className="invalid-feedback d-block text-danger mt-2">
              {errors.OTP.message}
            </div>
          )}

                     {errors.recovery_code && isRecoveryMode && (
            <div className="invalid-feedback d-block text-danger mt-2">
              {errors.recovery_code.message}
            </div>
          )}

                    <div className="mt-4 d-flex align-items-center  justify-content-between align-items-center  gap-1 w-75">
                      <div className="d-flex align-items-center justify-content-center gap-1" onClick={() => setRemember(!remember)} style={{ cursor: "pointer"}} >
                      <input
                        type="checkbox"
                        checked={remember}
                        // onChange={(e) => setRemember(e.target.checked)}
                        style={{cursor:"pointer"}}
                      />
                      <label className="text-center" style={{ cursor: "pointer"}}>Remember me</label>
</div>
<div>
 <button
              type="button"
              className="add_btn "
              onClick={toggleMode}
            >
              {isRecoveryMode ? "OTP" : "Recovery code"}
            </button></div>

                    </div>
                  </div>

                  <div className="d-grid w-25">
                    <button
                      type="submit"
                      className="auth_btn"
                      disabled={loading}
                    >
                      {loading ? <BtnLoader /> : "Submit"}
                    </button>
                  </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default TwoFactorAuth;
